export interface Position {
  left: number
  top: number
}

export const adjustElementPosition = (
  element: HTMLElement,
  position: Position,
  margin = 8,
): Position => {
  const rect = element.getBoundingClientRect()
  const vw = window.innerWidth
  const vh = window.innerHeight

  let { left, top } = position

  const halfWidth = rect.width / 2
  const minCenter = margin + halfWidth
  const maxCenter = vw - margin - halfWidth

  if (left < minCenter) {
    left = minCenter
  } else if (left > maxCenter) {
    left = maxCenter
  }

  const minTop = margin
  const maxTop = vh - margin - rect.height

  if (top < minTop) {
    top = minTop
  } else if (top > maxTop) {
    top = maxTop
  }

  return { left, top }
}

export const calculateRelativePosition = (
  targetElement: HTMLElement,
  referenceElement: HTMLElement,
): Position => {
  const referenceRect = referenceElement.getBoundingClientRect()

  return {
    left: referenceRect.left + referenceRect.width / 2,
    top: referenceRect.top - 8,
  }
}

export const isElementInViewport = (
  element: HTMLElement,
  margin = 0,
): boolean => {
  const rect = element.getBoundingClientRect()
  const vw = window.innerWidth
  const vh = window.innerHeight

  return (
    rect.left >= margin
    && rect.right <= vw - margin
    && rect.top >= margin
    && rect.bottom <= vh - margin
  )
}
